<script setup>
import {ref} from "vue";

const props = defineProps({
    message: String
})

const showTooltip = ref(false); // Controla a visibilidade do tooltip

const toggleTooltip = () => {
    showTooltip.value = !showTooltip.value; // Alterna a visibilidade
};

</script>

<template>
  <v-sheet variant="flat" class="d-inline-block cursor-pointer ml-1" @click="toggleTooltip">
    <v-icon icon="mdi-information-outline" size="18" color="info"></v-icon>
    <v-tooltip activator="parent" location="top" v-model="showTooltip" max-width="300">{{ props.message }}</v-tooltip>
  </v-sheet>
</template>
